import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { reportWebVitals } from './reportWebVitals';
import { REACT_APP_SENTRY_DSN, REACT_APP_SENTRY_ENVIRONMENT } from './config';
import * as Sentry from '@sentry/react';
import { initSentry } from './utils/sentry';
import { initAmplitude } from './utils/amplitude';
import { updateInitialMetadata } from './hooks/useMetadata';
import { loadRuntimeFlags } from './intake/runtimeFlags';

// Inicializar Sentry para el monitoreo de errores
if (REACT_APP_SENTRY_DSN && REACT_APP_SENTRY_ENVIRONMENT) {
  initSentry(REACT_APP_SENTRY_DSN);
  // Test log para verificar que Sentry Logs funciona
  Sentry.logger.info('User triggered test log', { log_source: 'sentry_test' });
}

initAmplitude();



// Actualizar el título inmediatamente antes de que React se monte
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => {
    updateInitialMetadata();
  });
} else {
  // El DOM ya está listo
  updateInitialMetadata();
}

const root = ReactDOM.createRoot(document.getElementById('root')!);

// flags.json can turn intake on over a build compiled off (STG MX). The quote bounce
// (`allowsApplicationWithoutLegacyQuoteForm`) and the MX quote CTAs (`isIntakeChatEnabled`)
// read the flag on first paint and do not re-render when it arrives, so the first render
// waits. The fetch is capped at ~600ms (abort alone does not unblock a connect
// that never gets headers); a rejection still paints (fail-open to the build).
// public/index.html shows a loader in #root until this render replaces it.
const renderApp = () => {
  root.render(
    <React.StrictMode>
      <App />
    </React.StrictMode>
  );
};
void loadRuntimeFlags().then(renderApp, renderApp);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals(() => { });
